(() => {
  function init(scope) {
    scope.querySelectorAll('[data-ha-routes]').forEach(root => {
      if (root.dataset.ready) return;
      const tabs = [...root.querySelectorAll('[data-route-tab]')];
      const panels = [...root.querySelectorAll('[data-route-panel]')];
      if (tabs.length !== panels.length || !tabs.length) return;
      const list = root.querySelector('[data-route-tabs]');
      list.setAttribute('role', 'tablist');
      list.hidden = false;
      tabs.forEach((tab, i) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[i].id);
        panels[i].setAttribute('role', 'tabpanel');
        panels[i].setAttribute('aria-labelledby', tab.id);
        panels[i].tabIndex = 0;
      });
      function select(index, focus = false) {
        tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          panels[i].setAttribute('aria-hidden', String(!active));
          panels[i].inert = !active;
        });
        if (focus) tabs[index].focus();
      }
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(i));
        tab.addEventListener('keydown', event => {
          const index = { ArrowRight: (i + 1) % tabs.length, ArrowLeft: (i + tabs.length - 1) % tabs.length, Home: 0, End: tabs.length - 1 }[event.key];
          if (index === undefined) return;
          event.preventDefault();
          select(index, true);
        });
      });
      select(0);
      root.dataset.ready = 'true';
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
